import {
  add,
  sub,
  format,
  getDay,
  parseISO,
  getTime,
  differenceInMilliseconds,
  intervalToDuration,
  isBefore,
  isAfter,
  differenceInHours,
  isWithinInterval,
  parse,
} from 'date-fns'
import { getTimezoneOffset, utcToZonedTime } from 'date-fns-tz'
import wcs from '@/scripts/libs/wcs'
class RbDate {
  static getTimeZone(): string {
    const { locale } = wcs.getStoreConfig()
    return new Intl.DateTimeFormat(locale).resolvedOptions().timeZone
  }
  static isDateDaylightSavingTime(date: string): boolean {
    const parsedDate = parseISO(date)
    const timeZone = RbDate.getTimeZone()
    const timezoneOffset = getTimezoneOffset(timeZone, parsedDate)
    return (
      timezoneOffset !== getTimezoneOffset(timeZone, new Date(parsedDate.getUTCFullYear(), 0, 1))
    )
  }
  static getTimeDate(date?: any) {
    if (date) {
      return getTime(date)
    }
    return getTime(new Date())
  }

  static addDate(date = RbDate.getTimeDate(), options: any, dateFormat?: string) {
    if (dateFormat) {
      return RbDate.formatDate(add(date, options), dateFormat)
    }
    return add(date, options)
  }
  static subDate(date: Date | number = RbDate.getTimeDate(), options: any, dateFormat?: string) {
    if (dateFormat) {
      return RbDate.formatDate(sub(date, options), dateFormat)
    }
    return sub(date, options)
  }

  static fromZonedTimeDate(date?: any): Date {
    const timeZone = RbDate.getTimeZone()
    return utcToZonedTime(date || new Date(), timeZone)
  }

  static parseDate(date: string, format: string) {
    return parse(date, format, new Date())
  }

  static formatDate(date: number | Date, dateFormat: string, options?: any): string {
    return format(date, dateFormat, options)
  }
  static diffInMilliseconds(endDate: number | Date, start = RbDate.getTimeDate()) {
    return differenceInMilliseconds(endDate, start)
  }
  static parseIsoDate(date: string) {
    return parseISO(date)
  }
  static diffInHours(end: number, start: number) {
    return differenceInHours(end, start)
  }
  static calcInterval(start: number, end: number) {
    return intervalToDuration({ start: start, end: end })
  }
  static isBeforeDate(end: Date, current: number | Date = RbDate.getTimeDate()) {
    return isBefore(end, current)
  }
  static isAfterDate(end: Date, current: number | Date = RbDate.getTimeDate()) {
    return isAfter(end, current)
  }
  static isWithinIntervalDate(end: any, start: any, date: number | Date = RbDate.getTimeDate()) {
    return isWithinInterval(date, {
      start,
      end,
    })
  }
  static getDayNumber(d: number | Date) {
    return (getDay(d) + 6) % 7
  }
  static isDST(date: Date) {
    const timeZone = RbDate.getTimeZone()
    const januaryOffset = getTimezoneOffset(timeZone, new Date(date.getFullYear(), 0, 1)) // Offset di gennaio
    const julyOffset = getTimezoneOffset(timeZone, new Date(date.getFullYear(), 6, 1)) // Offset di luglio
    const currentOffset = getTimezoneOffset(timeZone, date)

    // Se l'offset corrente è diverso dall'offset di gennaio (inverno), è DST
    return currentOffset !== Math.min(januaryOffset, julyOffset)
  }
  static async getAllLocales() {
    return await import('date-fns/locale')
  }
}

export default RbDate
